import * as React from "react";
import {connect} from 'react-redux';
import {
  getInvoiceQuery,
} from './Selectors';
import _ from 'lodash';
import {getInvoices, setSelectedSoldTos, updateSecondaryAccounts} from '../../actions/InvoiceActions';
import {withRouter} from "react-router-dom";
import {useState} from "react";
import {useEffect} from "react";
import * as appConstants from "../../constants/ApplicationConstants";
import {getSoldToNames} from "../../requests/InvoiceRequests";
import {usePrevious} from "../../hooks";

export const InvoicesContext = React.createContext([]);

async function computeSoldToSelectAll(invoices, dispatch) {
    if (!invoices || invoices.length === 0) return;

    // Unique soldto_numbers
    const soldTos = [...new Set(invoices.map(inv => inv.soldto_number))];

    let listSet = {};

    // Fill from zzcustom if available
    invoices.forEach(inv => {
        if (inv.zzcustom && inv.zzcustom.soldtoad) {
            listSet[inv.soldto_number] = {
                PrimaryAcct: inv.soldto_number,
                Name: inv.zzcustom.soldtoad.name,
            };
        }
    });

    // Get remaining ones in a single API call
    const missingSoldTos = soldTos.filter(st => !listSet[st]);
    if (missingSoldTos.length > 0) {
        const soldTosResults = await getSoldToNames(missingSoldTos);
        for (let prop in soldTosResults) {
            listSet[prop] = {
                PrimaryAcct: prop,
                Name: soldTosResults[prop],
            };
        }
    }

    dispatch(setSelectedSoldTos(soldTos));
    updateSecondaryAccounts(dispatch, Object.values(listSet));
}


function InvoiceDataManager(props) {

  const [invoices, setInvoices] = useState([]);

  let invoiceSearchQuery = props.invoiceSearchQuery;
  let forceRefresh = props.forceRefresh;

  const prev = usePrevious({invoiceSearchQuery, forceRefresh});

  useEffect(() => {
    if (props.invoiceSearchQuery !== null ) {
      if(typeof prev === "undefined" ||!_.isEqual(prev.invoiceSearchQuery, invoiceSearchQuery) || prev.forceRefresh !== forceRefresh ){
          getInvoices(props.dispatch, props.invoiceSearchQuery).then(async ([invoices, _]) => {
          if (props.accountType === appConstants.ACCOUNT_PAYER_ALL) {
           await computeSoldToSelectAll(invoices, props.dispatch);
          }
        });
      }
    }
  }, [
    props.invoiceSearchQuery,
    props.forceRefresh
  ]);

  useEffect(() => {
    setInvoices(props.invoices);
  }, [
    props.invoices,
  ]);

  return <InvoicesContext.Provider value={invoices}>{props.render}</InvoicesContext.Provider>;
}

export default withRouter(connect((state, props) => {
  return {
    accountType: state.user_options.accountType,
    invoiceSearchQuery: getInvoiceQuery(state, props),
    invoices: state.default.invoices,
    forceRefresh: state.invoice.forceRefresh,
  };
})(InvoiceDataManager));
